export default __webpack_public_path__ + "static/media/CITi.b86aac64.png";